<template>
  <div>
    <!-- <div class="text-center mt-10" v-if="loading == 0">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div> -->
    <div v-if="loading == 0">
      <!--     <v-img
        :src="virtualRooms.dataPerfile.profile_background_image_path"
        height="250px"
      ></v-img> -->
      <v-card class="mx-auto" outlined>
        <!--    <v-row justify="center">
          <v-avatar size="150" style="position:relative; top: -70px">
            <v-img :src="virtualRooms.dataPerfile.profile_img_path">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey "
                  ></v-progress-circular>
                </v-row> </template
            ></v-img> </v-avatar
        ></v-row> -->

        <h1
          class="text-uppercase d-flex justify-center mb-2 title mt-n10 "
          style="position:relative;"
        >
          titulo
        </h1>

        <!--    <div class="text-center mt-n">
            <v-rating
              v-if="virtualRooms.dataPerfile.rating != 'null'"
              color="warning"
              length="5"
              size="35"
              :value="virtualRooms.dataPerfile.rating"
              readonly
            ></v-rating>
          </div> -->
        <!--     <v-fab-transition>
          <v-btn
            color="primary"
            fab
            dark
            small
            absolute
            top
            right
            @click="doCopy"
          >
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
        </v-fab-transition> -->

        <!-- <v-fab-transition>
          <div>
            <v-btn
              style=" margin-right: 50px;"
              color="primary"
              fab
              dark
              small
              absolute
              top
              right
              @click="doChat"
            >
              <v-icon>mdi-chat-plus</v-icon>
            </v-btn>
          </div>
        </v-fab-transition> -->

        <v-tabs color="deep-purple accent-4" centered v-model="tab">
          <v-tab
            class="text-uppercase  text-caption text-xs-font-weight-thin text-sm-body-2 text-md-body-1 text-lg-h6 text-xl-h6 mt-5"
            >Productos</v-tab
          >
          <v-tab
            class="text-uppercase  text-caption text-sm-body-2 text-md-body-1 text-lg-h6 text-xl-h6 mt-5"
            >Pedidos</v-tab
          >
          <!-- 
          <v-tab
            v-if="virtualRooms.dataImg.length > 0"
            class="text-uppercase  text-caption text-sm-body-2 text-md-body-1 text-lg-h6 text-xl-h6 mt-5"
            >{{ $t("lang.index.roomsPrefile.text3") }}</v-tab
          >
          <v-tab
            v-if="virtualRooms.dataVideo.length > 0"
            class="text-uppercase  text-caption text-sm-body-2 text-md-body-1 text-lg-h6 text-xl-h6 mt-5"
            >{{ $t("lang.index.roomsPrefile.text4") }}</v-tab
          >

          <v-tab
            v-if="virtualRooms.resultJsonPacks.length > 0"
            class="text-uppercase  text-caption text-sm-body-2 text-md-body-1 text-lg-h6 text-xl-h6 mt-5"
            >{{ $t("lang.index.roomsPrefile.text21") }}</v-tab
          > -->

          <v-tab-item key="1">
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-card-title>
                    <!--      <v-text-field
                      v-model=""
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field> -->
                    Productos
                  </v-card-title>

                  <v-btn
                    color="success"
                    block
                    large
                    rounded
                    @click.stop="modalNewEvent = true"
                    class="mt-5 mb-5"
                  >
                    <v-icon left>
                      mdi-package-variant-closed-plus
                    </v-icon>
                    Nuevo
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>

                  <v-data-table
                    :headers="headerProduct"
                    :items="dataTables"
                    :search="search"
                    :items-per-page="5"
                    class="elevation-1"
                  >
                    <template v-slot:item.photo="{ item }">
                      <v-img :src="item.photo" width="100" height="100">
                      </v-img>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        title="Editar"
                        small
                        class="mr-2"
                        @click="editarProducts(item)"
                      >
                        mdi-pencil
                      </v-icon>

                      <v-icon
                        class="mr-2"
                        :title="Eliminar"
                        small
                        @click="deleteProducts(item)"
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-data-table>
                  <!-- <Sessions :id="$route.params.id"/> --></v-col
                >
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item key="2">
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-card-title>
                    <!--      <v-text-field
                      v-model=""
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field> -->
                    Pedidos
                  </v-card-title>

                  <!--    <v-btn
                    color="success"
                    block
                    large
                    rounded
                    @click.stop="modalNewEvent = true"
                    class="mt-5 mb-5"
                  >
                    <v-icon left>
                      mdi-package-variant-closed-plus
                    </v-icon>
                    Nuevo
                  </v-btn> -->

                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchP"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>

                  <v-data-table
                    :headers="headerPedidos"
                    :items="dataTablesPedidos"
                    :search="searchP"
                    :items-per-page="5"
                    class="elevation-1"
                  >
                    <template v-slot:item.photo="{ item }">
                      <v-img :src="item.photo" width="100" height="100">
                      </v-img>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        title="Editar"
                        small
                        class="mr-2"
                        @click="editarProducts(item)"
                      >
                        mdi-pencil
                      </v-icon>

                      <v-icon
                        class="mr-2"
                        :title="Eliminar"
                        small
                        @click="deleteProducts(item)"
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-data-table>
                  <!-- <Sessions :id="$route.params.id"/> --></v-col
                >
              </v-row>
            </v-container>
          </v-tab-item>

          <!--  <v-tab-item key="2" v-if="virtualRooms.dataService.length > 0">
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <Services :dataService="virtualRooms.dataService"
                /></v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item key="3" v-if="virtualRooms.dataImg.length > 0">
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <GalleryImg :roomDataImgs="virtualRooms.dataImg"
                /></v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item key="4" v-if="virtualRooms.dataVideo.length > 0">
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <GalleryVideo :dataVideo="virtualRooms.dataVideo" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item key="5" v-if="virtualRooms.resultJsonPacks.length > 0">
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <Packs :resultJsonPacks="virtualRooms.resultJsonPacks" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item> -->
        </v-tabs>
      </v-card>
    </div>
    <!--   <v-container style="width:80%">
      <v-alert
        v-if="loading == 2"
        type="info"
        class="mt-10 ml-2 mr-2 textExoRegular"
        border="left"
        colored-border
        color="#016CB3"
        elevation="2"
      >
        {{ $t("lang.index.roomsPrefile.text19") }}
      </v-alert>
    </v-container> -->

    <modalNew
      :visible="modalNewEvent"
      @closeDialogNewEvent="closeDialogNewEvent"
      @updateProducts="loadData"
    ></modalNew>

    <modalEdit
      :visible="modalEditEvent"
      @closeDialogEditEvent="closeDialogEditEvent"
      :objEdit="objEdit"
      @updateProducts="loadData"
    ></modalEdit>

    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import moment from "moment";
import modalNew from "./modalNew";
import modalEdit from "./modalEdit";
/* import Sessions from "./Sessions.vue";
import GalleryImg from "./GalleryImg.vue";
import Services from "./Services.vue";
import GalleryVideo from "./GalleryVid.vue"; */
import { validationMixin } from "vuelidate";
import confirm from "@/components/Reusable/Confirm.vue";
/* import Packs from "./Packs.vue"; */
import {
  required,
  maxLength,
  numeric,
  requiredIf,
  decimal,
} from "vuelidate/lib/validators";

export default {
  name: "virtualClassRoomMain",
  mixins: [validationMixin],
  props: ["visible"],
  components: {
    modalNew,
    modalEdit,
    confirm,
  },

  data() {
    return {
      objEdit: null,
      search: "",
      tab: null,
      type: 0,
      modalNew: false,
      virtualRooms: "no",
      modalNewSession: false,
      dialogChat: false,
      formObj: {
        sms: "",
      },
      buttonLoading: false,
      loading: 0,
      headerProduct: [
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Marca", value: "brand" },
        { text: "Descripción", value: "description" },
        { text: "Precio", value: "price" },
        { text: "Stock", value: "stock" },
        { text: "Photo", value: "photo" },
        { text: "Ver", value: "actions" },
      ],
      dataTables: [],
      modalNewEvent: false,
      modalEditEvent: false,

      searchP: "",
      headerPedidos: [
        {
          text: "Orden",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Correo", value: "email" },
        { text: "Telefono", value: "phone" },
        { text: "Precio", value: "price" },
        { text: "Ver", value: "actions" },
      ],
      dataTablesPedidos: [],
    };
  },
  created() {},
  filters: {
    moment(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogNewEvent");
        }
      },
    },
    smsErrors() {
      const errors = [];
      if (!this.$v.formObj.sms.$dirty) return errors;
      !this.$v.formObj.sms.required && errors.push("Campo es requerido.");

      if (!this.$v.formObj.sms.$dirty) return errors;
      !this.$v.formObj.sms.maxLength &&
        errors.push("Máximo 250 caracteres en el mensaje.");

      return errors;
    },
  },
  validations: {
    formObj: {
      sms: { required, maxLength: maxLength(250) },
    },
  },
  watch: {},
  methods: {
    deleteProducts(obj) {
      this.$refs.confirm
        .open("Eliminar", "Eliminar Producto ?", {
          color: "primary",
        })
        .then((confirm) => {
          if (confirm) {
            this.$axios
              .delete("/product/delete", {
                data: {
                  id: obj.id_products,
                },
              })
              .then((response) => {
                this.$toast.info("Operación realizada con éxito", "");
                this.dataTables.splice(this.dataTables.indexOf(obj), 1);
              })
              .catch((error) => {
                this.$toast.warn("Problemas al realizar la operación");
              });
          }
        });
    },
    editarProducts(obj) {
      this.objEdit = obj;
      this.modalEditEvent = true;
    },
    closeDialogEditEvent() {
      this.modalEditEvent = false;
    },
    closeDialogNewEvent() {
      this.modalNewEvent = false;
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        this.buttonLoading = true;

        const formData = {
          userId: parseInt(this.$store.state.credentials.id),
          sms: this.formObj.sms,
          room_id: this.virtualRooms.dataPerfile.virtual_room_id,
          virtual_room_user_id: this.virtualRooms.dataPerfile
            .virtual_room_user_id,
        };
        this.$axios
          .post("/chatRequests/create-session-chat", formData)
          .then((response) => {
            this.$toast.success(
              "",
              this.$t("lang.index.roomsPrefile.text20"),
              3000
            );
            this.formObj.sms = "";
            this.buttonLoading = false;
            this.dialogChat = false;
          })
          .catch((error) => {
            this.buttonLoading = false;
          });
      }
    },
    loadData() {
      this.$axios
        .get("/api/get-product/admin")
        .then((response) => {
          this.dataTables = response.data.data;
        })
        .catch((error) => {
          alert("error");
        });

      this.$axios
        .get("/api/get-pedidos/admin")
        .then((response) => {
          this.dataTablesPedidos = response.data.data;
        })
        .catch((error) => {
          alert("error");
        });
    },
    loadInitial() {
      this.loadData();
      /*  this.virtualRooms = "";
      this.$axios
        .get("/virtualRoom/virtualRoom/" + this.$route.params.id)
        .then((res) => {
          if (res.data.status == 0) {
            this.virtualRooms = "";
            this.loading = 2;
          } else {
            this.virtualRooms = res.data.data;
            this.loading = 1;
          }
        })
        .catch((error) => {
          this.loading = 2;
        }); */
    },
  },
  mounted() {
    this.loadInitial();
  },
};
</script>
